import { useEffect, useState } from "react";

const ViewPDF = ({ data, length }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [erroreRender, setErroreRender] = useState(false);

  useEffect(() => {
    if (data && length > 0) {
      try {
        console.log('length: ',length);
        const base64 = data.replace("data:application/pdf;base64,", "");
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);

        // pulizia
        return () => URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore nel parsing del PDF:", error);
        setPdfUrl(null);
      }
    }
  }, [data, length]);

  return (
    <div className="col-lg-8">
      {pdfUrl && !erroreRender ? (
        <object
          width="100%"
          height="900"
          data={pdfUrl}
          type="application/pdf"
          onError={() => setErroreRender(true)} // fallback se il browser non riesce a renderizzare
        >
          <p>Il PDF non può essere visualizzato nel browser.</p>
        </object>
      ) : length > 0 ? (
        <div className="alert alert-warning" role="alert">
          Non è stato possibile visualizzare il PDF nel browser.
          <br />
          <a href={pdfUrl} download="documento.pdf" className="btn btn-primary mt-2">
            Scarica PDF
          </a>
        </div>
      ) : (
        <div className="alert alert-danger" role="alert">
          Non è stato caricato nessun PDF
        </div>
      )}
    </div>
  );
};

export default ViewPDF;
